import './page-dostavka.css';

import Container from '../../@common.blocks/Container';
import Title from '../../@common.blocks/Title';
import Text from '../../@common.blocks/Text';
import Men from '../../pictures/men.png';
const PageDostavka = () => {
  return (
    <>
      <Container>
        <div className="page-dostavka">
          <div className="page-dostavka__wrapper">
            <Title level="2" component="message">
              Оплата
            </Title>
            <Text component="p" section="dostavka">
              «DINAX SYSTEMS» работает исключительно по безналичному расчету.
              Реквизиты для оплаты будут указаны в счете после получения нами
              Вашей заявки.
              <Text component="p" section="dostavka">
                Условия отсрочки платежа и скидки оговариваются индивидуально с
                каждым клиентом в зависимости от приобретаемого объема и иных
                условий сотрудничества.
              </Text>
            </Text>
            <Title level="2" component="message">
              Доставка
            </Title>
            <Text component="p" section="dostavka">
              При заказе на сумму свыше 100 000 руб. мы осуществляем бесплатную
              доставку по Санкт-Петербургу. В остальных случаях условия доставки
              обсуждаются индивидуально.
            </Text>
            <div className="page-dostavka__wrapper-img">
              <img src={Men} alt="" />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};
export default PageDostavka;
